// extracted by mini-css-extract-plugin
export default {"tooltip":"uP-z","arrow":"vP-z"};